import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY

// In development, allow app to start without env vars (for testing UI)
let supabase: ReturnType<typeof createClient>

if (!supabaseUrl || !supabaseAnonKey) {
  if (process.env.NODE_ENV === 'development') {
    // Only log to console, don't show to users
    if (typeof window === 'undefined') {
      // Server-side: use console.error (won't show in browser)
      console.error('[Supabase] Missing environment variables. Some features will not work.')
    }
    // Create a dummy client to prevent crashes
    supabase = createClient(
      'https://placeholder.supabase.co',
      'placeholder-key'
    )
  } else {
    throw new Error('Missing Supabase environment variables')
  }
} else {
  // Configure Supabase client with automatic token refresh and session persistence
  // This ensures users stay logged in even when tokens expire
  supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      autoRefreshToken: true, // Automatically refresh expired tokens
      persistSession: true, // Persist session in localStorage
      detectSessionInUrl: false, // Don't detect session in URL (we handle it manually)
    },
  })
}

export { supabase }
